import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect () {
    window.vidyardEmbed
      ? this.registerProgressEvents(window.vidyardEmbed)
      : (window.onVidyardAPI = (vidyardEmbed) => this.registerProgressEvents(vidyardEmbed));
  }

  registerProgressEvents (vidyardEmbed) {
    vidyardEmbed.api.addReadyListener((data, player) => {
      let playerData = player.element.parentElement.dataset
      // Seek to where the user left of last time if applicable
      if (localStorage.getItem(`${playerData.userId}.vidyard.${player.uuid}`)) {
        player.seek(localStorage.getItem(`${playerData.userId}.vidyard.${player.uuid}`))
      }
      // Saves the time progress to play from there if they leave the video
      player.on('timeupdate', function (eventTime) { localStorage.setItem(`${playerData.userId}.vidyard.${player.uuid}`, eventTime);});

      // Actions that fire at the specified percentage watched
      vidyardEmbed.api.progressEvents((result) => {
        // Manually calculate the progress percentage so that we can track it if they leave the video
        let totalPercentage = localStorage.getItem(`${playerData.userId}.vidyard.${result.player.uuid}.percentage`)
        let currentPercentage = result.event
        if (totalPercentage) {
          totalPercentage = Number(totalPercentage) + currentPercentage
        } else {
          totalPercentage = currentPercentage
        }

        localStorage.setItem(`${playerData.userId}.vidyard.${result.player.uuid}.percentage`, totalPercentage)

        let resultPlayerData = result.player.element.parentElement.dataset
        // If the course is a recommendation, trigger a lesson started notification to the admin
        if (result.event == 0 && resultPlayerData.lessonStartedUrl) {
          this.markLessonStarted(resultPlayerData.lessonStartedUrl);
        } else if (result.event == 70 || totalPercentage == 70) { // Lesson is marked completed if 70% video watched progress is reached
          // TODO: This conditional temporarily prevents making multiple API calls to update the lesson. The actual cause for the 
          // multiple API calls isn't known at the moment but could be linked to tubo page loads.
          if (localStorage.getItem(`vidyard.${result.player.uuid}.complete`)) {return}
          console.log('lesson complete');
          this.completeLesson(resultPlayerData.lessonUrl);
          localStorage.setItem(`vidyard.${result.player.uuid}.complete`, true)
        }
      }, [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70]) // Track every 5% progress so we can accurately track it when they leave the video
    })
  }

  completeLesson (url) {
    let csrfToken = $('meta[name="csrf-token"]').attr('content');

    $.ajax({
      type: 'patch',
      url: url,
      headers: {
        'X-CSRF-Token': csrfToken
      }
    })
  }

  markLessonStarted(url) {
    let csrfToken = $('meta[name="csrf-token"]').attr('content');

    $.ajax({
      type: 'patch',
      url: url,
      headers: {
        'X-CSRF-Token': csrfToken
      }
    })
  }
}